export const GET_LOGIN = "get_login"; //登录
export const GET_PERMISSION = "get_permission"; //获取权限
export const SET_SCROLL_LEFT = "set_scroll_left";
export const SET_SCROLL_TOP = "set_scroll_top";
export const CHANGE_SETTING = "change_setting";
export const SET_SIZE = "set_size";
